import { image } from "./elements/logo";
import { PTSans } from "./elements/font";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

let printDateFormatted;
let createdAtDateFormatted;
let updatedAtDateFormatted;
let week;
let variety;
let farm;
let title;
let exworks;
let fixed;
let page;
let currentLineStarting = 4.3;

// TODO: Refactor
export const handlePrintPDF = async (primaryOrder, sequencedOrders, packs, producers, weeks, varieties) => {
  const doc = new jsPDF({
    orientation: "landscape",
    unit: "cm",
  });

  doc.addFileToVFS("PTSans.ttf", PTSans);
  doc.addFont("PTSans.ttf", "PTSans", "normal");

  doc.setFont("PTSans"); // set font
  page = 1;

  currentLineStarting = 4.3;

  primaryOrder.exworks = primaryOrder.exworks.toString().toLowerCase() == "true" ? true : false;
  primaryOrder.fixed = primaryOrder.fixed.toString().toLowerCase() == "true" ? true : false;
  primaryOrder.local = primaryOrder.local.toString().toLowerCase() == "true" ? true : false;

  const resultFarm = producers.filter((item) => {
    return item.code == primaryOrder.farm;
  });
  farm = resultFarm;

  printDateFormatted = new Date(primaryOrder.printdate).toUTCString().split(" ").slice(0, 4).join(" ");
  createdAtDateFormatted = new Date(primaryOrder.created_at).toUTCString().split(" ").slice(0, 4).join(" ");
  updatedAtDateFormatted = new Date(primaryOrder.updated_at).toUTCString().split(" ").slice(0, 4).join(" ");
  let primaryOrdervariety = varieties.filter((item) => {
    return item.id == primaryOrder.variety;
  });
  let primaryOrderweek = weeks.filter((item) => {
    return item.id == primaryOrder.week;
  });

  const currentLineSpacing = 0.5;

  Promise.all(
    sequencedOrders.data.reverse().map((result) => {
      variety = varieties.filter((item) => item.id == result.variety);
      week = weeks.filter((item) => item.id == result.week);

      fixed = result.fixed;
      exworks = result.exworks;

      let dipCaption = result.exworks ? "ExW" : "DIP";

      title = variety[0].name + " (" + variety[0].code + ") " + " - V" + primaryOrder.revision;
      printHeader(doc, farm, week, printDateFormatted, createdAtDateFormatted, updatedAtDateFormatted);
      currentLineStarting = printDetail(doc, currentLineSpacing, dipCaption, result.instructions, packs);

      page = doc.getNumberOfPages();
      doc.setPage(page);
    }),
  ).then(() => {
    if (currentLineStarting >= 17) {
      page++;
      doc.addPage();
      doc.setPage(page);
    }
    printPageNumbers(doc);
    printROE_Comments(doc, primaryOrder.exchange, primaryOrder.comment);

    doc.save(
      primaryOrderweek[0].week.replace(" ", "") +
        "_" +
        resultFarm[0].name +
        "_" +
        primaryOrdervariety[0].name +
        "(" +
        primaryOrdervariety[0].code +
        ")_V" +
        primaryOrder.revision +
        ".pdf",
    );
  });
};

const printPageNumbers = (doc) => {
  let currentPage = 1;

  for (currentPage; currentPage <= page; currentPage++) {
    doc.setPage(currentPage);
    doc.setFontSize(10);
    doc.text(28.5, 20.5, `Page ${currentPage} of ${page}`, null, null, "right");
  }
};

const printHeader = async (doc, farm, week, printdate, createdAtDate, updatedAtDate) => {
  doc.addImage(image, "PNG", 1, 0.5, 7, 2.5);
  doc.setFontSize(16);
  doc.setFontStyle("bold");
  doc.setFont("PTSans"); // set font
  doc.text(9, 1, "PAKINSTRUKSIE - " + farm[0].name, null, null, "left");
  doc.setFontStyle("normal");
  doc.setFont("PTSans"); // set font
  doc.text(9, 1.8, `Inname week ${week[0].week} ${title && title.length > 0 ? `- ${title}` : ""}`, null, null, "left");
  // doc.text(9, 2.6, printdate, null, null, "left");
  doc.setFontSize(12);
  doc.text(24.5, 2, "Created:", null, null, "right");
  doc.text(25, 2, createdAtDate, null, null, "left");
  doc.text(24.5, 2.5, "Updated:", null, null, "right");
  doc.text(25, 2.5, updatedAtDate, null, null, "left");
  doc.setFontSize(16);
};

const printROE_Comments = (doc, exchange, comments) => {
  doc.setFontSize(10);
  doc.text(1, 16.1, "RATE OF EXCHANGE");
  doc.setLineWidth(0.01);
  doc.line(1, 16.35, 4.1, 16.35, "S"); //  Top
  doc.line(1, 16.35, 1, 19.9, "S"); //  Left
  doc.line(1, 19.9, 4.1, 19.9, "S"); //  Bottom
  doc.line(4.1, 16.35, 4.1, 19.9, "S"); //  Right
  doc.text(1.6, 17.5, "USD");
  doc.text(2.4, 17.5, ":  " + exchange.usd);
  doc.text(1.6, 18, "CAD");
  doc.text(2.4, 18, ":  " + exchange.cad);
  doc.text(1.6, 18.5, "EUR");
  doc.text(2.4, 18.5, ":  " + exchange.eur);
  doc.text(1.6, 19, "GBP");
  doc.text(2.4, 19, ":  " + exchange.gbp);

  // comments
  if (comments && comments.length > 0) {
    doc.text(5, 16.1, "COMMENTS");
    doc.setLineWidth(0.01);

    //Comment Box
    doc.line(5, 16.35, 28.5, 16.35, "S"); //  Top
    doc.line(5, 16.35, 5, 19.9, "S"); //  Left
    doc.line(5, 19.9, 28.5, 19.9, "S"); //  Bottom
    doc.line(28.5, 16.35, 28.5, 19.9, "S"); //  Right

    let fromTop = 16.5,
      leftSide = 5.1;

    comments.split("\n").map((comment) => {
      // any text length greater than 153 should wrap to the next line
      if (comment.toString().length < 153) {
        const text = comment.toString();
        doc.text(leftSide, fromTop + 0.19, text, null, null, "left");
        fromTop = fromTop + 0.44;
      } else {
        let wrapped = doc.splitTextToSize(comment.toString(), 28.2 - 5.1);
        wrapped.map((text) => {
          doc.text(leftSide, fromTop + 0.19, text, null, null, "left");
          fromTop = fromTop + 0.44;
        });
      }
    });
  }
};

const printDetail = (pdf: jsPDF, currentLineSpacing, dipCaption, instructions = [], packs = []) => {
  const fullWidth = pdf.internal.pageSize.getWidth();
  const formatted = instructions.map((row) => ({
    ...row,
    order: `${row.groupnum}.${row.groupline}`,
    dip_range: `${row.dipmin}-${row.dipmax}`,
    fob: `${row.currency} ${row.fob}`,
  }));

  // rect around title text
  pdf.setFillColor("#000");
  pdf.rect(currentLineSpacing + 0.5, 3.6, fullWidth - 2, 0.75, "F");

  // title above data grid
  pdf.setPage(page);
  pdf.setFontSize(10);
  pdf.setTextColor(255, 255, 255);
  pdf.text(title, currentLineSpacing + 0.8, 4, null, null, "left");

  // reset fill color and text color
  pdf.setFillColor("#fff");
  pdf.setTextColor(0, 0, 0);

  const columns = [
    { dataKey: "order", header: "Order", halign: "center" },
    { dataKey: "volume", header: "Volume", halign: "center" },
    { dataKey: "region", header: "TR", halign: "center" },
    { dataKey: "market", header: "TM", halign: "center" },
    { dataKey: "country", header: "TC", halign: "center" },
    { dataKey: "class", header: "Class", halign: "center" },
    { dataKey: "count", header: "Count", halign: "center" },
    { dataKey: "coldroom", header: "Cold Store", halign: "center" },
    { dataKey: "pack_carton", header: "Ctns", halign: "center" },
    { dataKey: "pack_code", header: "Pack", halign: "center" },
    { dataKey: "brand", header: "Brand", halign: "center" },
    { dataKey: "inventory_display", header: "Inventory", halign: "center" },
    // { dataKey: "prod_group", header: "Prod Group", halign: "center" },
    { dataKey: "mgp", header: "Terms", halign: "center" },
    { dataKey: "fob", header: "FOB", halign: "center" },
    { dataKey: "dip", header: "DIP", halign: "center" },
    { dataKey: "dip_range", header: "EX DIP Range", halign: "center" },
    { dataKey: "prod_char", header: "Agent", halign: "center" },
    { dataKey: "comment", header: "Comment", halign: "center" },
  ];

  autoTable(pdf, {
    theme: "plain",
    margin: [1, 1, 1, 1],
    startY: currentLineStarting,
    columns: columns,
    body: formatted,
    showFoot: "lastPage",
    tableLineColor: [0, 0, 0],
    styles: { fontSize: 9, textColor: [0, 0, 0], font: "PTSans", cellPadding: [0.1, 0, 0.1, 0] },
    columnStyles: {
      order: { halign: "center" },
      volume: { halign: "center" },
      region: { halign: "center" },
      market: { halign: "center" },
      country: { halign: "center" },
      class: { halign: "center" },
      count: { halign: "center" },
      coldroom: { halign: "center" },
      pack_carton: { halign: "center" },
      pack_code: { halign: "center" },
      brand: { halign: "center" },
      inventory_display: { halign: "center" },
      // prod_group: { halign: "center" },
      mgp: { halign: "center" },
      fob: { halign: "center" },
      dip: { halign: "center" },
      dip_range: { halign: "center" },
      prod_char: { halign: "center" },
      comment: { halign: "center" },
    },
    headStyles: { fontStyle: "bold", halign: "center", textColor: [255, 255, 255], lineColor: [0, 0, 0], lineWidth: 0.01, fillColor: [0, 0, 0] },
    bodyStyles: { lineColor: [0, 0, 0], lineWidth: 0.01 },
    didDrawPage: (data) => {
      currentLineStarting = data.cursor.y;
    },
  });

  return currentLineStarting;
};
